import { render, staticRenderFns } from "./Basededatos.vue?vue&type=template&id=0dd05625"
import script from "./Basededatos.vue?vue&type=script&lang=js"
export * from "./Basededatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports